import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-nigeria-home-loan-affordability.component.scss';
import * as $ from 'jquery';
var valueCalculatorNigeriaHomeLoanAffordabilityDob = new Date();
var CalculatorNigeriaHomeLoanAffordability = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorNigeriaHomeLoanAffordability, _super);
    function CalculatorNigeriaHomeLoanAffordability(element) {
        return _super.call(this, element) || this;
    }
    CalculatorNigeriaHomeLoanAffordability.prototype.init = function () {
        var _this = this;
        valueCalculatorNigeriaHomeLoanAffordabilityDob = new Date();
        this.inputDOB = this.element.querySelector('input.js-dob');
        this.inputNetSalary = this.element.querySelector('input[name=net_salary]');
        this.inputTotalMonthly = this.element.querySelector('input[name=loan_repayments]');
        this.inputOtherMonthly = this.element.querySelector('input[name=other_loan_repayments]');
        this.inputTenorMonths = this.element.querySelector('input.js-term');
        var inputTenorMonths = this.inputTenorMonths;
        [
            this.inputNetSalary,
            this.inputTotalMonthly,
            this.inputOtherMonthly
        ].forEach(function (input) {
            if (!input)
                return;
            input.addEventListener('input', function (e) {
                var cursor = e.target.selectionStart;
                var numbers = e.target.value.replace(/\s/g, '');
                e.target.value = _this.formatInputNumber(numbers);
                e.target.setSelectionRange(cursor, cursor);
            });
        });
        this.containerCalculatorFormForm = this.element.querySelector('.calculator-form__form');
        var containerCalculatorFormForm = this.containerCalculatorFormForm;
        this.containerEligibilityAmount = this.element.querySelector('.js-eligibility-amount');
        this.containerNetWorth = this.element.querySelector('.js-net-monthly-income');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        var dateDiffInYears = this.dateDiffInYears;
        var showAgeMessage = this.showAgeMessage;
        $(document).ready(function () {
            // start dateppicker
            $('input.js-dob').datepicker({
                format: "dd/mm/yyyy",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true
            });
            var dateNew = new Date();
            var dateYear = dateNew.getFullYear();
            var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
            var dateDay = dateNew.getDate().toString().padStart(2, "0");
            // let dateFormatted: any = dateYear+'/'+dateMonth+'/'+dateDay;
            var dateFormatted = dateDay + '/' + dateMonth + '/' + dateYear;
            $('input.js-dob').datepicker('setDate', dateFormatted);
            $('input.js-dob').datepicker().on('changeDate', function (e) {
                valueCalculatorNigeriaHomeLoanAffordabilityDob = e.date;
                var dateTestNew = e.date;
                var dateTestOld = new Date();
                var tenorMonths = parseInt(inputTenorMonths.value);
                dateTestOld.setMonth(dateTestOld.getMonth() + tenorMonths);
                showAgeMessage(dateDiffInYears(dateTestNew, dateTestOld), containerCalculatorFormForm);
            });
        });
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.bindEvents = function () {
        var _this = this;
        if (this.inputTenorMonths) {
            this.inputTenorMonths.addEventListener('keyup', function (event) {
                var dateTestNew = valueCalculatorNigeriaHomeLoanAffordabilityDob;
                var dateTestOld = new Date();
                var tenorMonths = parseInt(event.target.value);
                dateTestOld.setMonth(dateTestOld.getMonth() + tenorMonths);
                _this.showAgeMessage(_this.dateDiffInYears(dateTestNew, dateTestOld), _this.containerCalculatorFormForm);
            });
        }
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            setTimeout(function () {
                var dateNew = new Date();
                var dateYear = dateNew.getFullYear();
                var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
                var dateDay = dateNew.getDate().toString().padStart(2, "0");
                // let dateFormatted: any = dateYear+'/'+dateMonth+'/'+dateDay;
                var dateFormatted = dateDay + '/' + dateMonth + '/' + dateYear;
                $('input.js-dob').datepicker('setDate', dateFormatted);
            }, 500);
        });
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.calculate = function () {
        this.containerEligibilityAmount.innerHTML = '-';
        this.containerNetWorth.innerHTML = '-';
        if (this.inputDOB.value.length > 0 &&
            this.inputTenorMonths.value.length > 0 &&
            this.inputNetSalary.value.length > 0 &&
            this.inputTotalMonthly.value.length > 0 &&
            this.inputOtherMonthly.value.length > 0) {
            var inputDOB = parseFloat(this.inputDOB.value);
            var inputTenorMonths = parseFloat(this.inputTenorMonths.value);
            var inputNetSalary = this.getNumericValue(this.inputNetSalary.value);
            var inputTotalMonthly = this.getNumericValue(this.inputTotalMonthly.value);
            var inputOtherMonthly = this.getNumericValue(this.inputOtherMonthly.value);
            var rate = 19 / 1200;
            var totalExpenses = inputNetSalary - (inputTotalMonthly + inputOtherMonthly);
            var totalLeft = inputNetSalary - totalExpenses;
            var percentage = totalLeft / inputNetSalary;
            var nper = inputTenorMonths * 12;
            var pmt = (0.45 * inputNetSalary) - (inputNetSalary - totalExpenses);
            var pv = this.PV(rate, nper, pmt, 0, 1) * -1;
            // this.containerEligibilityAmount.innerHTML = this.roundFormatterV2(pv, 0, false);
            this.containerEligibilityAmount.innerHTML = this.roundFormatter(pv, 2, true);
            this.containerNetWorth.innerHTML = this.roundFormatter(totalExpenses, 2, true);
        }
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.dateDiffInYears = function (dateold, datenew) {
        var ynew = datenew.getFullYear();
        var mnew = datenew.getMonth();
        var dnew = datenew.getDate();
        var yold = dateold.getFullYear();
        var mold = dateold.getMonth();
        var dold = dateold.getDate();
        var diff = ynew - yold;
        if (mold > mnew)
            diff--;
        else {
            if (mold == mnew) {
                if (dold > dnew)
                    diff--;
            }
        }
        return diff;
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.showAgeMessage = function (ageByThen, container) {
        if (ageByThen === void 0) { ageByThen = 0; }
        if (container === void 0) { container = undefined; }
        var errorMessageContainers = Array.from(document.querySelectorAll('.calculator-nigeria-home-loan-affordability__errormessage'));
        errorMessageContainers.map(function (containerError) {
            containerError.remove();
        });
        if (ageByThen >= 60) {
            var containerMain = Array.from(document.querySelectorAll('.calculator-nigeria-home-loan-affordability__form'));
            var containerErrorMessage_1 = document.createElement('div');
            containerErrorMessage_1.classList.add('calculator-nigeria-home-loan-affordability__errormessage');
            containerErrorMessage_1.innerHTML = "Based on your current age and tenor, you will be above 60 when the term ends. Reduce your tenor to become eligible.";
            containerMain.map(function (containerMainItem) {
                var calculatorForm = containerMainItem.querySelector('.calculator-form__form');
                var calculatorFormButton = containerMainItem.querySelector('.js-calculator-calculate');
                calculatorFormButton.classList.add('button--disabled');
                calculatorForm.insertBefore(containerErrorMessage_1, calculatorForm.children[0]);
            });
        }
        else {
            var containerMain = Array.from(document.querySelectorAll('.calculator-nigeria-home-loan-affordability__form'));
            containerMain.map(function (containerMainItem) {
                var calculatorFormButton = containerMainItem.querySelector('.js-calculator-calculate');
                calculatorFormButton.classList.remove('button--disabled');
            });
        }
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.formatInputNumber = function (value) {
        return value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.getNumericValue = function (value) {
        return parseFloat(value.replace(/\s/g, '')) || 0;
    };
    CalculatorNigeriaHomeLoanAffordability.prototype.PV = function (rate, nper, pmt, fv, type) {
        var pv_value = 0;
        rate = parseFloat(rate);
        nper = parseFloat(nper);
        pmt = parseFloat(pmt);
        fv = parseFloat(fv);
        if (nper == 0) {
            alert("Why do you want to test me with zeros?");
            return (0);
        }
        if (rate == 0) { // Interest rate is 0
            pv_value = -(fv + (pmt * nper));
        }
        else {
            var x = Math.pow(1 + rate, -nper);
            var y = Math.pow(1 + rate, nper);
            pv_value = -(x * (fv * rate - pmt + y * pmt)) / rate;
        }
        return pv_value;
    };
    return CalculatorNigeriaHomeLoanAffordability;
}(Base));
export { CalculatorNigeriaHomeLoanAffordability };



//////////////////
// WEBPACK FOOTER
// ./components-nigeria/calculator-nigeria-home-loan-affordability/calculator-nigeria-home-loan-affordability.component.ts
// module id = 727
// module chunks = 0